import React from 'react';
import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from 'react-router-dom';
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;

const SchoolsListPage = () => {
  const [schools, setSchools] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  /* ---------------- SCHOOL LIST ---------------- */
  const fetchContent = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${baseAPIUrl}admin/general_settings/get_schools/`,
        { withCredentials: true }
      );

      if (res.data.status === 1 && res.data.data) {
        setSchools(res.data.data || []);
        console.log(schools);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContent();
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    scrollToTop();
  }, []);

  const technojunior = [
    { id: 'Techno Junior School- Chandan nagar', name: 'Techno Junior School- Chandan nagar', location: 'Chandan nagar', heroImage: '/pictures/schools/school-1.png', description: 'Excellence in education at Chandan nagar', address: 'Chandannagar, Bhadreswar, Hooghly-Chinsurah, West Bengal,', contact: '098308 11940' },
    { id: 'Techno Junior School- Rangali Bazna', name: 'Techno Junior School- Rangali Bazna', location: 'Rangali Bazna', heroImage: '/pictures/schools/school-1.png', description: 'Quality education in Rangali Bazna', address: 'Madarihat, Paschim Khaibari, Near Rangali Bazna Chawpathi, Alipurduar', contact: '7001871855/9531752786' },
    { id: 'Techno Junior School- Selimpur', name: 'Techno Junior School- Selimpur', location: 'Selimpur', heroImage: '/pictures/schools/school-1.png', description: 'Premier education in Selimpur', address: '110/20 Selimpur Road Kolkata 700031, Kolkata, india, West Bengal', contact: '082408 82434' },
    { id: 'Techno Junior School- Pranami Mandir Road', name: 'Techno Junior School- Pranami Mandir Road', location: 'Siliguri', heroImage: '/pictures/schools/techno-junior-siliguri-pranami-mandir-road.jpeg', address: 'Pranami Mandir Road, Siliguri, West Bengal', contact: '98000 04845'}
  ];

  const upcommingschool = [
    { id: 'TIGPS-Chanchal', name: 'TIGPS Chanchal', location: 'Chanchal', heroImage: '/pictures/schools/school-1.png', description: 'Excellence in education at Chanchal', address: 'Coming Soon', contact: '7230023231' },

  ];

  return (
    <div className="schools-list-page">
      {/* Hero Section */}
      <section style={{ background: 'rgb(100, 19, 32)', color: 'white', padding: '60px 20px' }}>
        <div className="container">
          <h1 style={{ fontSize: '3rem', textAlign: 'center', marginBottom: '20px' }}>Our Schools</h1>
          <p style={{ fontSize: '1.2rem', textAlign: 'center', maxWidth: '800px', margin: '0 auto' }}>
            Discover excellence across {schools.length} campuses in West Bengal
          </p>
        </div>
      </section>

      {/* Schools Grid */}
      <section style={{ padding: '60px 20px', background: '#f8f9fa' }}>
        <div className="container" style={{ maxWidth: '1400px', margin: '0 auto' }}>
          <div className="row">
            <h2 className='school-title'>TIG PUBLIC SCHOOLS</h2>
            {schools.map((school) => (
              <div key={school.id} className="col-lg-4 col-md-6 mb-4">
                <Link
                  to={`/${school.school_slug}`}
                  style={{ textDecoration: 'none', color: 'inherit' }}
                  target='_blank'
                >
                  <div className="card h-100" style={{
                    border: 'none',
                    borderRadius: '15px',
                    overflow: 'hidden',
                    boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                  }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-5px)';
                      e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.1)';
                    }}>
                    <div style={{ position: 'relative', height: '200px', overflow: 'hidden' }}>
                      <img
                        src={`${baseAPIUrl}assets/images/schools/${school.school_image}`}
                        alt={school.school_name}
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover'
                        }}
                      />
                      <div style={{
                        position: 'absolute',
                        top: '15px',
                        right: '15px',
                        background: 'rgb(100, 19, 32)',
                        color: 'white',
                        padding: '5px 15px',
                        borderRadius: '20px',
                        fontSize: '0.9rem',
                      }}>
                        {school.school_location}
                      </div>
                    </div>

                    <div className="card-body" style={{ padding: '25px' }}>
                      <h5 style={{
                        color: 'rgb(100, 19, 32)',
                        marginBottom: '15px',
                        fontSize: '1.5rem',
                      }}>
                        {school.school_name}
                      </h5>

                      <p className='school-list-p'>
                        {school.school_description}
                      </p>

                      {school.school_address && (
                        <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '10px' }}>
                          <span style={{ color: 'rgb(100, 19, 32)', marginRight: '8px', fontSize: '0.9rem' }}><i className="fas fa-map-marker-alt"></i></span>
                          <p className='school-list-p'>
                            {school.school_address.length > 60 ? school.school_address.substring(0, 60) + '...' : school.school_address}
                          </p>
                        </div>
                      )}

                      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                        <span style={{ color: 'rgb(100, 19, 32)', marginRight: '8px', fontSize: '0.9rem' }}><i className="fas fa-phone-alt"></i></span>
                        <p className='school-list-p'>{school.school_contact}</p>
                      </div>

                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginTop: '20px',
                        paddingTop: '15px',
                        borderTop: '1px solid #eee'
                      }}>
                        <span style={{
                          background: 'rgb(100, 19, 32)',
                          color: 'white',
                          padding: '8px 16px',
                          borderRadius: '20px',
                          fontSize: '0.8rem',
                          fontWeight: 'bold'
                        }}>
                          View Details
                        </span>
                        <span style={{ color: 'rgb(100, 19, 32)', fontSize: '1.2rem' }}>→</span>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="card h-100" style={{
                border: 'none',
                borderRadius: '15px',
                overflow: 'hidden',
                boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease'
              }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.1)';
                }}>
                <div style={{ position: 'relative', height: '200px', overflow: 'hidden' }}>
                  <img
                    src="/pictures/schools/school-1.png"
                    alt="TIGPS - Kanchrapara"
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover'
                    }}
                  />
                  <div style={{
                    position: 'absolute',
                    top: '15px',
                    right: '15px',
                    background: 'rgb(100, 19, 32)',
                    color: 'white',
                    padding: '5px 15px',
                    borderRadius: '20px',
                    fontSize: '0.9rem',
                  }}>
                    Kanchrapara
                  </div>
                </div>

                <div className="card-body" style={{ padding: '25px' }}>
                  <h5 style={{
                    color: 'rgb(100, 19, 32)',
                    marginBottom: '15px',
                    fontSize: '1.5rem',
                  }}>
                    TIGPS - Kanchrapara
                  </h5>

                  <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '10px' }}>
                    <span style={{ color: 'rgb(100, 19, 32)', marginRight: '8px', fontSize: '0.9rem' }}><i className="fas fa-map-marker-alt"></i></span>
                    <p className='school-list-p'>
                      127, Kabiguru Rabindra Path, Kanchrapara, North 24 Parganas, 743145
                    </p>
                  </div>


                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                    <span style={{ color: 'rgb(100, 19, 32)', marginRight: '8px', fontSize: '0.9rem' }}><i className="fas fa-phone-alt"></i></span>
                    <p className='school-list-p'>8013191616 / 8617299628</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="card h-100" style={{
                border: 'none',
                borderRadius: '15px',
                overflow: 'hidden',
                boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease'
              }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.1)';
                }}>
                <div style={{ position: 'relative', height: '200px', overflow: 'hidden' }}>
                  <img
                    src="/pictures/schools/school-1.png"
                    alt="TIGPS - Sodepur"
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover'
                    }}
                  />
                  <div style={{
                    position: 'absolute',
                    top: '15px',
                    right: '15px',
                    background: 'rgb(100, 19, 32)',
                    color: 'white',
                    padding: '5px 15px',
                    borderRadius: '20px',
                    fontSize: '0.9rem',
                  }}>
                    Sodepur
                  </div>
                </div>

                <div className="card-body" style={{ padding: '25px' }}>
                  <h5 style={{
                    color: 'rgb(100, 19, 32)',
                    marginBottom: '15px',
                    fontSize: '1.5rem',
                  }}>
                    TIGPS - Sodepur
                  </h5>

                  <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '10px' }}>
                    <span style={{ color: 'rgb(100, 19, 32)', marginRight: '8px', fontSize: '0.9rem' }}><i className="fas fa-map-marker-alt"></i></span>
                    <p className='school-list-p'>
                      Anandanagar Ghola Sodepur, Kolkata, India, West Bengal
                    </p>
                  </div>


                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                    <span style={{ color: 'rgb(100, 19, 32)', marginRight: '8px', fontSize: '0.9rem' }}><i className="fas fa-phone-alt"></i></span>
                    <p className='school-list-p'>76879 42227</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section style={{ padding: '60px 20px', background: '#f8f9fa' }}>
        <div className="container" style={{ maxWidth: '1400px', margin: '0 auto' }}>
          <div className="row">
            <h2 className='school-title'>TECHNO JUNIOR SCHOOLS</h2>

            {technojunior.map((school) => (
              <div key={school.id} className="col-lg-4 col-md-6 mb-4">

                <div className="card h-100" style={{
                  border: 'none',
                  borderRadius: '15px',
                  overflow: 'hidden',
                  boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-5px)';
                    e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.1)';
                  }}>
                  <div style={{ position: 'relative', height: '200px', overflow: 'hidden' }}>
                    <img
                      src={school.heroImage}
                      alt={school.name}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover'
                      }}
                    />
                    <div style={{
                      position: 'absolute',
                      top: '15px',
                      right: '15px',
                      background: 'rgb(100, 19, 32)',
                      color: 'white',
                      padding: '5px 15px',
                      borderRadius: '20px',
                      fontSize: '0.8rem',
                      fontWeight: 'bold'
                    }}>
                      {school.location}
                    </div>
                  </div>

                  <div className="card-body" style={{ padding: '25px' }}>
                    <h5 style={{
                      color: 'rgb(100, 19, 32)',
                      marginBottom: '15px',
                      fontSize: '1.1rem',
                      fontWeight: 'bold'
                    }}>
                      {school.name}
                    </h5>

                    <p style={{
                      color: '#666',
                      fontSize: '0.9rem',
                      marginBottom: '15px',
                      lineHeight: '1.5'
                    }}>
                      {school.description}
                    </p>

                    {school.address && (
                      <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '10px' }}>
                        <span style={{ color: 'rgb(100, 19, 32)', marginRight: '8px', fontSize: '0.9rem' }}><i className="fas fa-map-marker-alt"></i></span>
                        <p style={{
                          margin: 0,
                          fontSize: '0.85rem',
                          color: '#666',
                          lineHeight: '1.4'
                        }}>
                          {school.address.length > 60 ? school.address.substring(0, 60) + '...' : school.address}
                        </p>
                      </div>
                    )}

                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                      <span style={{ color: 'rgb(100, 19, 32)', marginRight: '8px', fontSize: '0.9rem' }}><i className="fas fa-phone-alt"></i></span>
                      <p style={{ margin: 0, fontSize: '0.85rem', color: '#666' }}>{school.contact}</p>
                    </div>
                  </div>
                </div>

              </div>
            ))}
          </div>
        </div>
      </section >

      <section style={{ padding: '60px 20px', background: '#f8f9fa' }}>
        <div className="container" style={{ maxWidth: '1400px', margin: '0 auto' }}>
          <div className="row">
            <h2 className='school-title'>UPCOMING SCHOOL</h2>

            {upcommingschool.map((school) => (
              <div key={school.id} className="col-lg-4 col-md-6 mb-4">

                <div className="card h-100" style={{
                  border: 'none',
                  borderRadius: '15px',
                  overflow: 'hidden',
                  boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-5px)';
                    e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.1)';
                  }}>
                  <div style={{ position: 'relative', height: '200px', overflow: 'hidden' }}>
                    <img
                      src={school.heroImage}
                      alt={school.name}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover'
                      }}
                    />
                    <div style={{
                      position: 'absolute',
                      top: '15px',
                      right: '15px',
                      background: 'rgb(100, 19, 32)',
                      color: 'white',
                      padding: '5px 15px',
                      borderRadius: '20px',
                      fontSize: '0.8rem',
                      fontWeight: 'bold'
                    }}>
                      {school.location}
                    </div>
                  </div>

                  <div className="card-body" style={{ padding: '25px' }}>
                    <h5 style={{
                      color: 'rgb(100, 19, 32)',
                      marginBottom: '15px',
                      fontSize: '1.1rem',
                      fontWeight: 'bold'
                    }}>
                      {school.name}
                    </h5>

                    <p style={{
                      color: '#666',
                      fontSize: '0.9rem',
                      marginBottom: '15px',
                      lineHeight: '1.5'
                    }}>
                      {school.description}
                    </p>

                    {school.address && (
                      <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '10px' }}>
                        <span style={{ color: 'rgb(100, 19, 32)', marginRight: '8px', fontSize: '0.9rem' }}><i className="fas fa-map-marker-alt"></i></span>
                        <p style={{
                          margin: 0,
                          fontSize: '0.85rem',
                          color: '#666',
                          lineHeight: '1.4'
                        }}>
                          {school.address.length > 60 ? school.address.substring(0, 60) + '...' : school.address}
                        </p>
                      </div>
                    )}

                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                      <span style={{ color: 'rgb(100, 19, 32)', marginRight: '8px', fontSize: '0.9rem' }}><i className="fas fa-phone-alt"></i></span>
                      <p style={{ margin: 0, fontSize: '0.85rem', color: '#666' }}>{school.contact}</p>
                    </div>


                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section style={{ padding: '60px 20px', background: 'white' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', textAlign: 'center' }}>
          <h2 style={{ color: 'rgb(100, 19, 32)', marginBottom: '20px' }}>Ready to Join Our Network?</h2>
          <p style={{ fontSize: '1.1rem', marginBottom: '30px', color: '#666' }}>
            Choose the campus nearest to you and start your educational journey
          </p>
          <a href="/contact"
            style={{
              background: 'rgb(100, 19, 32)',
              color: 'white',
              padding: '15px 30px',
              textDecoration: 'none',
              borderRadius: '5px',
              fontSize: '1.1rem',
            }}>
            Contact Us for More Information
          </a>
        </div>
      </section>
    </div>
  );
}

export default SchoolsListPage;
